import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { postUrlChange } from '../../messageChannel/postNewMessages';

export const usePostUrlChange = (): void => {
  const location = useLocation();

  useEffect(() => {
    // Let the widget know the URL changed for notifications sync purposes
    postUrlChange(location.pathname);
  }, [location.pathname]);
};
